import '../../shared/Services.scss';
import Header from '../../components/Header/Header';
import RetireesPackages from './RetireesPackages';
import CustomPackage from '../../components/CustomPackage/CustomPackage';
import Footer from '../../components/Footer/Footer';
import React from 'react';

function Retirees(props) {
    return (
        <div className="demographic">
            <Header/>
            <div className="demographic__body">
                <div className="demographic__body--format">
                    <h1 className="page-title">Retirees</h1>
                    <RetireesPackages/>
                    <CustomPackage/>
                </div>    
            </div>
            <Footer/>
        </div>
    );
}

export default Retirees;